import React from "react";
import { LuAlertTriangle } from "react-icons/lu";

import { formatQty } from "../../static/materialLine";

type Props = {
  // The bar size sent, with its bars in stock (none when the form wasn't sent the stock).
  size: { stock?: number } | null;
  // The bars the order sends of it.
  qty: number;
};

// A cutting order sending more bars of a size than are in stock. Only a warning: the order still saves, and the
// stock goes below zero.
const StockShortNote = ({ size, qty }: Props) => {
  if (!size || size.stock === undefined || qty <= 0 || qty <= size.stock) {
    return null;
  }

  return (
    <p className="flex items-start gap-1 text-xs font-medium text-red-600">
      <LuAlertTriangle className="mt-px h-3.5 w-3.5 flex-shrink-0" />
      {size.stock > 0
        ? `સ્ટોક માં ફક્ત ${formatQty(size.stock)} બાર છે`
        : "સ્ટોક માં આ સાઈઝ ના બાર નથી"}
    </p>
  );
};

export default StockShortNote;
